import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'
import type { TaxRefundDeliveryMethod } from './TaxRefundDeliveryMethod'

/**
 * Whether the refund is for a personal or business taxpayer.
 */
export type TaxRefundType = 'Personal' | 'Business' | 'Unspecified'

export type TaxRefundMethodVersionProps = ModelProps<TaxRefundMethodVersion>

/**
 * A version of a means by which a tax refund is delivered.
 */
export class TaxRefundMethodVersion extends Model<TaxRefundMethodVersion> {
  id = Id.none

  @observable accessor version = 0
  @observable accessor refundType: TaxRefundType = 'Unspecified'
  @observable accessor deliveryMethod: TaxRefundDeliveryMethod | null = null
  @observable accessor createdAt = unixEpoch()
  @observable accessor updatedAt = unixEpoch()
}

/**
 * Formats an ID string for the backing collection of tax refund method
 * versions.
 */
export const TaxRefundMethodVersionId = {
  from: (id: Id, version: number | undefined): string => {
    if (version === undefined) {
      throw new TypeError('Tax refund method version ID cannot be undefined')
    }

    return `${Id.assert(id)}@v${version}`
  },
}
